export default "__VITE_ASSET__C$JzzqHo__"